"use client";

import { theme } from "@/config/theme";
import { SCContainerContent } from "@/utils/styledComponents";
import { EmblaOptionsType } from "embla-carousel";
import { useTranslations } from "next-intl";
import styled from "styled-components";
import EmblaCarousel from "./Component-EmblaCarousel-SellingPoints";

import imageParentPortal from "/public/media/images/image-parentportal.png";
import imageComprehensiveCurriculum from "/public/media/images/image-comprehensivecurriculum.png";
import imageGlobalReach from "/public/media/images/image-globalreach.png";
import iconParentPortal from "/public/media/images/icon-parentportal.png";
import iconComprehensiveCurriculum from "/public/media/images/icon-comprehensivecurriculum.png";
import iconGlobalReach from "/public/media/images/icon-globalreach.png";

const SellingPoints = () => {
    const t = useTranslations("SellingPoints");

    const sellingPointList = [
        {
            imgSrc: imageParentPortal,
            iconSrc: iconParentPortal,
            title: t("parentPortal-title-text"),
            alt: t("parentPortal-title-alt"),
            subtitle: t("parentPortal-description-text")
        },
        {
            imgSrc: imageComprehensiveCurriculum,
            iconSrc: iconComprehensiveCurriculum,
            title: t("comprehensiveCorriculum-title-text"),
            alt: t("comprehensiveCorriculum-title-alt"),
            subtitle: t("comprehensiveCorriculum-description-text")
        },
        {
            imgSrc: imageGlobalReach,
            iconSrc: iconGlobalReach,
            title: t("globalReach-title-text"),
            alt: t("globalReach-title-alt"),
            subtitle: t("globalReach-description-text")
        }
    ];

    const OPTIONS: EmblaOptionsType = { loop: true };
    // const SLIDE_COUNT = 5;
    // const SLIDES = Array.from(Array(SLIDE_COUNT).keys());
    const SLIDES = sellingPointList;

    return (
        <SCSellingPoints>
            <SCSellingPointsContent>
                <EmblaCarousel slides={SLIDES} options={OPTIONS} />
            </SCSellingPointsContent>
        </SCSellingPoints>
    );
};

export default SellingPoints;

const SCSellingPoints = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    // height: 75vh;
    // max-height: 650px;
    padding: ${theme["spacing-lxl"]} 0;
`;

const SCSellingPointsContent = styled(SCContainerContent)`
    display: flex;
    flex-direction: column;
`;
